/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Backbone from 'common/vendor/backbone';
import React from 'react';
import { HistoryListenerArguments, ListenerFunc, listeners } from './listeners';

const getRouteContextState: (
  args: HistoryListenerArguments,
) => RouteContextState = ({ location }) => {
  const identifier = location.pathname.split('/')[1];

  const isBoardRoute = identifier === 'b';
  const isCardRoute = identifier === 'c';
  // The /search route may or may not contain query parameters, so an exact
  // match here won't do. Using RegExp in place of `new URL` or
  // `identifier.startsWith` because either would require polyfilling for IE11.
  // Revisit this if/when the parsing logic and/or route metadata extraction
  // become too cumbersome.
  const isSearchRoute = /^search/.test(identifier);

  return {
    isBoardRoute,
    isCardRoute,
    isSearchRoute,
  };
};

export interface RouteContextState {
  isBoardRoute: boolean;
  isCardRoute: boolean;
  isSearchRoute: boolean;
}

export interface RouteContextProps {
  children: (state: RouteContextState) => React.ReactNode;
}

export default class RouteContext extends React.Component<
  RouteContextProps,
  RouteContextState
> {
  state = getRouteContextState({
    location: Backbone.history.location,
  });

  updateState: ListenerFunc = ({ location }) => {
    this.setState(getRouteContextState({ location }));
  };

  componentDidMount() {
    listeners.add(this.updateState);
  }

  componentWillUnmount() {
    listeners.delete(this.updateState);
  }

  render() {
    return this.props.children(this.state);
  }
}



// WEBPACK FOOTER //
// ./app/common/components/route-context/route-context.tsx